import { jsx } from 'react/jsx-runtime';
import { createContext } from 'react';

const FeatureListContext = /*#__PURE__*/ createContext({
    variant: 'primary',
    direction: 'vertical',
    size: 'base',
    iconSize: 'default'
});
const FeatureListProvider = ({ variant, direction, size = 'base', iconSize = 'default', children })=>{
    return jsx(FeatureListContext.Provider, {
        value: {
            variant,
            direction,
            size,
            iconSize
        },
        children: children
    });
};

export { FeatureListContext, FeatureListProvider };
//# sourceMappingURL=FeatureList.Context.es.js.map
